import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const TemperaturePage = lazy(() => import("./TemperaturePage"));

const TemperaturePageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <TemperaturePage />
    </Suspense>
  );
};

export default TemperaturePageLazy;
